import ApiService from './ApiService.js';
const uuidv1 = require('uuid/v1');
import moment from 'moment'
var erpService = {
    findAll: function($data)
     {
        return new Promise(function(resolve,reject) {
            var $options= {};
            $options.url ="erp"
            $options.method="get"
            if(!$data) {
                $options.data = $data
            }
            ApiService.request($options)
                .then(response => {
                   // console.log('Gpt the data');
                    resolve(response.data.data)
                }).catch(error=> {
                    reject(error);
                })
        });

    },
    getDataFromErp: async function($data,$db) {
        return new Promise(function(resolve,reject) {
            var $options= {};

            $options.url ="integrations/?source="+$data+"&db="+$db
            $options.method="get"
            if(!$data) {
                $options.data = $data
            }
            ApiService.request($options)
                .then(response => {
                   // console.log('Gpt the data');
                    resolve(response.data.data)
                }).catch(error=> {
                    reject(error);
                })
        });
        
    },
    getErpMap: function($data) {
        return new Promise(function(resolve,reject) {
            var $options= {};
            $options.url ="erpMap/"+$data.id
            console.log($options.url)
            $options.method="get"
            if(!$data) {
                $options.data = $data
            }
            ApiService.request($options)
                .then(response => {
                   // console.log('Gpt the data');
                    resolve(response.data.data)
                }).catch(error=> {
                    reject(error);
                })
        });

    },
    findOne: function($data)
     {
        return new Promise(function(resolve,reject) {
            var $options= {};
            $options.url ="erp/"+$data.id
            console.log($options.url)
            $options.method="get"
            if(!$data) {
                $options.data = $data
            }
            ApiService.request($options)
                .then(response => {
                   // console.log('Gpt the data');
                    resolve(response.data.data)
                }).catch(error=> {
                    reject(error);
                })
        });

    },
    save: function ($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
           // $data.modified_by=JSON.parse(localStorage.getItem('tiburaXtend')).data.User.id
            //delete $data.created
            //delete $data.modified 
            $options.data=$data
            console.log($data)
            $options.url = "erp/"+$data.id;
            $options.method="post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
            });
    },
    
    create: function ($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            // $data.company_id=JSON.parse(localStorage.getItem('tiburaXtend')).data.User.company_id
            // $data.created_by=JSON.parse(localStorage.getItem('tiburaXtend')).data.User.id
            // $data.modified_by=JSON.parse(localStorage.getItem('tiburaXtend')).data.User.id
            // $data.created = moment($data.created).format('YYYY-MM-DD')
            // $data.modified = moment($data.modified).format('YYYY-MM-DD')
            $options.data=$data;
            $options.url = "erp";
            $options.method="post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
            });
    },
    validate: function($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.data={};
            console.log($data)
            $options.url ='erp/validate'
            $options.data = $data;
            ApiService.request($options) 
                .then(response => {

                }).catch(error => {

                });
            });

    },
    formatData: function($data) 
    {
        var $i =0;
        var $indexData = $data.data.data;
        return $indexData;
    }
};
export default erpService;